(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7905],{

/***/ 50430:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _lingui_react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14744);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _Navbar__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41557);
/* harmony import */ var _seo_NotFoundSeo__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83293);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);









var Custom404 = function Custom404(_ref) {
  var _ref$withNavbar = _ref.withNavbar,
      withNavbar = _ref$withNavbar === void 0 ? false : _ref$withNavbar;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_seo_NotFoundSeo__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
      className: "min-h-screen bg-gray-100",
      children: [withNavbar && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_Navbar__WEBPACK_IMPORTED_MODULE_3__.Navbar, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
        className: "py-10",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("header", {
          className: "mb-4",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
            className: "max-w-7xl mx-auto px-8",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_0__/* .Trans */ .cC, {
              id: "Page not found"
            })
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("main", {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
            className: "max-w-7xl mx-auto px-8",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
              href: "/",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_0__/* .Trans */ .cC, {
                  id: "Go back home"
                })
              })
            })
          })
        })]
      })]
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Custom404);

/***/ }),

/***/ 50362:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ ImageExpand; }
/* harmony export */ });
/* harmony import */ var _mui_icons_material_Fullscreen__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55343);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);





var ImageExpand = function ImageExpand(_ref) {
  var image = _ref.image,
      onRemoveExpand = _ref.onRemoveExpand;

  if (!image) {
    return null;
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
    className: "min-h-screen absolute overflow-hidden grid grid-cols-1 mx-auto px-8 md:h-full w-full bg-gray-100",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
      className: "absolute grid h-6 justify-end w-full z-40 p-8 lg:px-8 mx-auto",
      onClick: function onClick() {
        return onRemoveExpand();
      },
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_mui_icons_material_Fullscreen__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        className: "w-6 h-6"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
      className: "w-full h-full absolute md:mt-10",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_0___default()), {
        src: image.url,
        alt: image.alt,
        layout: "fill",
        objectFit: "scale-down"
      })
    })]
  });
};

/***/ }),

/***/ 85584:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ VideoExpand; }
/* harmony export */ });
/* harmony import */ var _mui_icons_material_Fullscreen__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55343);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _lib_util__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4829);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);





var VideoExpand = function VideoExpand(_ref) {
  var video = _ref.video,
      onRemoveExpand = _ref.onRemoveExpand;

  if (!video) {
    return null;
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
    className: "min-h-screen absolute grid grid-cols-1 mx-auto px-8 md:h-full w-full bg-gray-100",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
      className: "absolute grid h-6 justify-end w-full z-40 p-8 lg:px-8 mx-auto",
      onClick: function onClick() {
        return onRemoveExpand();
      },
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_icons_material_Fullscreen__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        className: "w-6 h-6"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
      className: "w-full h-full absolute md:mt-10 flex justify-center items-center",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("iframe", {
        src: "https://www.youtube.com/embed/" + (0,_lib_util__WEBPACK_IMPORTED_MODULE_3__/* .getYouTubeIDFromURL */ .rT)(video.url) + "?autoplay=1",
        className: "w-full h-4/5 md:w-4/5",
        allow: "autoplay",
        allowFullScreen: true
      })
    })]
  });
};

/***/ }),

/***/ 48321:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _lingui_react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14744);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);

 // export interface NewArrivalBadgeProps {}



var NewArrivalBadge = function NewArrivalBadge() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
    className: "flex flex-row rounded-lg overflow-hidden",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
      className: "bg-red-500 text-white px-2 py-3 font-semibold text-xs m-auto uppercase",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_0__/* .Trans */ .cC, {
        id: "New"
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (NewArrivalBadge);

/***/ }),

/***/ 89624:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ product_ProductDetailTabs; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(92777);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(82262);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(10748);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js + 1 modules
var inherits = __webpack_require__(45959);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(63553);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(37247);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/@lingui/core/build/esm/index.js + 1 modules
var esm = __webpack_require__(32601);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js
var Box = __webpack_require__(99226);
// EXTERNAL MODULE: ./node_modules/@mui/material/Tab/Tab.js + 1 modules
var Tab = __webpack_require__(40044);
// EXTERNAL MODULE: ./node_modules/@mui/material/Tabs/Tabs.js + 5 modules
var Tabs = __webpack_require__(37023);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@lingui/react/build/esm/index.js
var build_esm = __webpack_require__(14744);
// EXTERNAL MODULE: ./node_modules/editorjs-blocks-react-renderer/dist/index.js
var dist = __webpack_require__(23851);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(17674);
;// CONCATENATED MODULE: ./components/shared/hooks/useStateWithCallbackLazy.ts



function useStateWithCallbackLazy(initialValue) {
  var callbackRef = react.useRef(null);

  var _React$useState = react.useState(initialValue),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      value = _React$useState2[0],
      setValue = _React$useState2[1];

  react.useEffect(function () {
    if (callbackRef.current) {
      callbackRef.current(value);
      callbackRef.current = null;
    }
  }, [value]);
  var setValueWithCallback = react.useCallback(function (newValue, callback) {
    callbackRef.current = callback || null;
    return setValue(newValue);
  }, []);
  return [value, setValueWithCallback];
}

/* harmony default export */ var hooks_useStateWithCallbackLazy = (useStateWithCallbackLazy);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/shared/Truncate.tsx



var _excluded = ["children", "ellipsis", "lines", "trimWhitespace", "onTruncate", "width"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var getElementInnerText = function getElementInnerText(node) {
  var _test$contentKey;

  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

  if (!node) {
    return fallback;
  }

  var div = document.createElement("div");
  var contentKey = "innerText" in node ? "innerText" : "textContent";
  div.innerHTML = node.innerHTML.replace(/\r\n|\r|\n/g, " ");
  var text = div[contentKey];
  var test = document.createElement("div");
  test.innerHTML = "foo<br/>bar";

  if (((_test$contentKey = test[contentKey]) === null || _test$contentKey === void 0 ? void 0 : _test$contentKey.replace(/\r\n|\r/g, "\n")) !== "foo\nbar") {
    div.innerHTML = div.innerHTML.replace(/<br.*?[\/]?>/gi, "\n");
    text = div[contentKey];
  }

  return text || fallback;
};

var trimRight = function trimRight(text) {
  return text.trimEnd();
};

var Truncate = function Truncate(_ref) {
  var children = _ref.children,
      _ref$ellipsis = _ref.ellipsis,
      ellipsis = _ref$ellipsis === void 0 ? "..." : _ref$ellipsis,
      _ref$lines = _ref.lines,
      numLines = _ref$lines === void 0 ? 1 : _ref$lines,
      _ref$trimWhitespace = _ref.trimWhitespace,
      trimWhitespace = _ref$trimWhitespace === void 0 ? false : _ref$trimWhitespace,
      onTruncate = _ref.onTruncate,
      width = _ref.width,
      spanProps = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var contentRef = (0,react.useRef)(null);
  var textRef = (0,react.useRef)(null);
  var ellipsisRef = (0,react.useRef)(null);
  var timoutIdRef = (0,react.useRef)(null);
  var canvasContext = (0,react.useRef)(null);

  var _useStateWithCallback = hooks_useStateWithCallbackLazy(0),
      _useStateWithCallback2 = (0,slicedToArray/* default */.Z)(_useStateWithCallback, 2),
      targetWidth = _useStateWithCallback2[0],
      setTargetWidth = _useStateWithCallback2[1];

  (0,react.useEffect)(function () {
    var canvas = document.createElement("canvas");
    canvasContext.current = canvas.getContext("2d");
    var ellipsis = ellipsisRef.current;
    return function () {
      timoutIdRef.current && cancelAnimationFrame(timoutIdRef.current);

      if (ellipsis) {
        var _ellipsis$parentNode;

        (_ellipsis$parentNode = ellipsis.parentNode) === null || _ellipsis$parentNode === void 0 ? void 0 : _ellipsis$parentNode.removeChild(ellipsis);
      }
    };
  }, []);
  var calcualteLayout = (0,react.useCallback)(function (callback) {
    if (!contentRef.current) {
      return;
    }

    var result = width;

    if (!result) {
      if (contentRef.current.parentNode instanceof HTMLElement) {
        var _contentRef$current$p;

        result = Math.floor((_contentRef$current$p = contentRef.current.parentNode) === null || _contentRef$current$p === void 0 ? void 0 : _contentRef$current$p.getBoundingClientRect().width);
      } else {
        result = 0;
      }
    } // Delay calculation until parent node is inserted to the document
    // Mounting order in React is ChildComponent, ParentComponent


    if (!result) {
      return window.requestAnimationFrame(function () {
        return calcualteLayout(callback);
      });
    }

    var style = window.getComputedStyle(contentRef.current);
    var font = [style.fontWeight, style.fontStyle, style.fontSize, style.fontFamily].join(" ");

    if (canvasContext.current) {
      canvasContext.current.font = font;
    }

    setTargetWidth(result, callback);
  }, [setTargetWidth, width]);
  (0,react.useEffect)(function () {
    var onResize = function onResize() {
      calcualteLayout();
    };

    calcualteLayout(function () {
      // Node not needed in document tree to read its content
      if (textRef.current) {
        var _textRef$current$pare;

        (_textRef$current$pare = textRef.current.parentNode) === null || _textRef$current$pare === void 0 ? void 0 : _textRef$current$pare.removeChild(textRef.current);
      }
    });
    window.addEventListener("resize", onResize);
    return function () {
      return window.removeEventListener("resize", onResize);
    };
  }, [width, calcualteLayout]);
  var handleTruncate = (0,react.useCallback)(function (didTruncate) {
    if (typeof onTruncate === "function") {
      timoutIdRef.current = window.requestAnimationFrame(function () {
        onTruncate(didTruncate);
      });
    }
  }, [onTruncate]);
  var renderLine = (0,react.useCallback)(function (line, i, arr) {
    if (i === arr.length - 1) {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
        children: [line, i === numLines - 1 && ellipsis]
      }, i);
    } else {
      var br = /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}, i + "br");

      if (line) {
        return [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: line
        }, i), br];
      } else {
        return br;
      }
    }
  }, [ellipsis, numLines]);

  var measureWidth = function measureWidth(text) {
    var _canvasContext$curren;

    return ((_canvasContext$curren = canvasContext.current) === null || _canvasContext$curren === void 0 ? void 0 : _canvasContext$curren.measureText(text).width) || 0;
  };

  var renderContent = (0,react.useMemo)(function () {
    var mounted = !!(contentRef.current && targetWidth);

    if (!mounted) {
      return null;
    }

    var getLines = function getLines() {
      var _ellipsisRef$current;

      var lines = [];
      var text = getElementInnerText(textRef.current);
      var textLines = text.split("\n").map(function (line) {
        return line.split(" ");
      });
      var didTruncate = true;
      var ellipsisWidth = ((_ellipsisRef$current = ellipsisRef.current) === null || _ellipsisRef$current === void 0 ? void 0 : _ellipsisRef$current.offsetWidth) || 0;

      for (var line = 1; line <= numLines; line++) {
        var textWords = textLines[0]; // Handle newline

        if (textWords.length === 0) {
          lines.push();
          textLines.shift();
          line--;
          continue;
        }

        var resultLine = textWords.join(" ");

        if (measureWidth(resultLine) <= targetWidth) {
          if (textLines.length === 1) {
            // Line is end of text and fits without truncating
            didTruncate = false;
            lines.push(resultLine);
            break;
          }
        }

        if (line === numLines) {
          // Binary search determining the longest possible line inluding truncate string
          var textRest = textWords.join(" ");
          var lower = 0;
          var upper = textRest.length - 1;

          while (lower <= upper) {
            var middle = Math.floor((lower + upper) / 2);
            var testLine = textRest.slice(0, middle + 1);

            if (measureWidth(testLine) + ellipsisWidth <= targetWidth) {
              lower = middle + 1;
            } else {
              upper = middle - 1;
            }
          }

          var lastLineText = textRest.slice(0, lower);

          if (trimWhitespace) {
            lastLineText = trimRight(lastLineText); // Remove blank lines from the end of text

            while (!lastLineText.length && lines.length) {
              var prevLine = lines.pop();
              lastLineText = trimRight(prevLine || "");
            }
          }

          lines.push(lastLineText);
        } else {
          // Binary search determining when the line breaks
          var _lower = 0;

          var _upper = textWords.length - 1;

          while (_lower <= _upper) {
            var _middle = Math.floor((_lower + _upper) / 2);

            var _testLine = textWords.slice(0, _middle + 1).join(" ");

            if (measureWidth(_testLine) <= targetWidth) {
              _lower = _middle + 1;
            } else {
              _upper = _middle - 1;
            }
          } // The first word of this line is too long to fit it


          if (_lower === 0) {
            // Jump to processing of last line
            line = numLines - 1;
            continue;
          }

          resultLine = textWords.slice(0, _lower).join(" ");
          textLines[0].splice(0, _lower);
          lines.push(resultLine);
        }
      }

      handleTruncate(didTruncate);
      return lines;
    };

    if (numLines > 0) {
      return getLines().map(renderLine);
    }

    return children;
  }, [children, handleTruncate, numLines, renderLine, targetWidth, trimWhitespace]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("span", _objectSpread(_objectSpread({}, spanProps), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      ref: contentRef,
      children: renderContent
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      ref: textRef,
      children: children
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      ref: ellipsisRef,
      style: {
        position: "fixed",
        visibility: "hidden",
        top: 0,
        left: 0
      },
      children: ellipsis
    })]
  }));
};

/* harmony default export */ var shared_Truncate = (Truncate);
;// CONCATENATED MODULE: ./components/shared/ShowMore.tsx








function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }








var ShowMore = /*#__PURE__*/function (_React$Component) {
  (0,inherits/* default */.Z)(ShowMore, _React$Component);

  var _super = _createSuper(ShowMore);

  function ShowMore(props) {
    var _this;

    (0,classCallCheck/* default */.Z)(this, ShowMore);

    _this = _super.call(this, props);

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "articleRef", void 0);

    _this.onExpandClick = _this.onExpandClick.bind((0,assertThisInitialized/* default */.Z)(_this));
    _this.setExpanded = _this.setExpanded.bind((0,assertThisInitialized/* default */.Z)(_this));
    _this.scrollIntoView = _this.scrollIntoView.bind((0,assertThisInitialized/* default */.Z)(_this));
    _this.state = {
      expanded: props.expanded || false
    };
    _this.articleRef = /*#__PURE__*/react.createRef();
    return _this;
  }

  (0,createClass/* default */.Z)(ShowMore, [{
    key: "setExpanded",
    value: function setExpanded() {
      var expandable = this.props.expandable;

      if (!expandable) {
        return;
      }

      this.setState({
        expanded: true
      });
    }
  }, {
    key: "scrollIntoView",
    value: function scrollIntoView() {
      var _this$articleRef$curr;

      (_this$articleRef$curr = this.articleRef.current) === null || _this$articleRef$curr === void 0 ? void 0 : _this$articleRef$curr.scrollIntoView({
        behavior: "smooth",
        block: "center"
      });
    }
  }, {
    key: "onExpandClick",
    value: function onExpandClick(event) {
      event.preventDefault();
      this.setExpanded();
      var onExpandPress = this.props.onExpandPress;
      onExpandPress && onExpandPress();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          jsonStringData = _this$props.jsonStringData,
          _this$props$lines = _this$props.lines,
          lines = _this$props$lines === void 0 ? 3 : _this$props$lines,
          expandedProps = _this$props.expanded;
      var expanded = this.state.expanded;

      if (!jsonStringData) {
        return null;
      }

      var data;

      try {
        data = JSON.parse(jsonStringData);
      } catch (e) {
        console.error("Rich text data are not valid JSONString.");
        return null;
      }

      if (!data.time || !data.version || !data.blocks.length) {
        console.error("Rich text data not in the EditorJS format.");
        return null;
      }

      if (expanded || expandedProps) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          ref: this.articleRef,
          className: "text-sm prose lg:prose-s max-w-full",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((dist_default()), {
            data: data
          })
        });
      }

      return /*#__PURE__*/(0,jsx_runtime.jsx)(shared_Truncate, {
        lines: expanded ? 0 : lines,
        ellipsis: /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
          children: ["...", /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            onClick: this.onExpandClick,
            className: "px-1 text-brand-blue",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(build_esm/* Trans */.cC, {
              id: "View more details"
            })
          })]
        }),
        className: "text-sm",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          ref: this.articleRef,
          className: "text-sm prose lg:prose-s max-w-full",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((dist_default()), {
            data: data
          })
        })
      });
    }
  }]);

  return ShowMore;
}(react.Component);

/* harmony default export */ var shared_ShowMore = (ShowMore);
;// CONCATENATED MODULE: ./components/product/ProductDetailTabs.tsx








var ProductDetailTabs_excluded = ["children", "value", "index"];

function ProductDetailTabs_createSuper(Derived) { var hasNativeReflectConstruct = ProductDetailTabs_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function ProductDetailTabs_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ProductDetailTabs_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ProductDetailTabs_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ProductDetailTabs_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ProductDetailTabs_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










function TabPanel(props) {
  var children = props.children,
      value = props.value,
      index = props.index,
      other = (0,objectWithoutProperties/* default */.Z)(props, ProductDetailTabs_excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", ProductDetailTabs_objectSpread(ProductDetailTabs_objectSpread({
    role: "tabpanel",
    hidden: value !== index,
    id: "simple-tabpanel-".concat(index),
    "aria-labelledby": "simple-tab-".concat(index)
  }, other), {}, {
    children: value === index && /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
      sx: {
        p: 3
      },
      children: children
    })
  }));
}

function a11yProps(index) {
  return {
    id: "simple-tab-".concat(index),
    "aria-controls": "simple-tabpanel-".concat(index)
  };
}

var ProductDetailTabs = /*#__PURE__*/function (_React$Component) {
  (0,inherits/* default */.Z)(ProductDetailTabs, _React$Component);

  var _super = ProductDetailTabs_createSuper(ProductDetailTabs);

  function ProductDetailTabs(props) {
    var _this;

    (0,classCallCheck/* default */.Z)(this, ProductDetailTabs);

    _this = _super.call(this, props);

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "showMoreRef", void 0);

    _this.state = {
      value: 0
    };
    _this.handleChange = _this.handleChange.bind((0,assertThisInitialized/* default */.Z)(_this));
    _this.expandDescription = _this.expandDescription.bind((0,assertThisInitialized/* default */.Z)(_this));
    _this.showMoreRef = /*#__PURE__*/react.createRef();
    return _this;
  }

  (0,createClass/* default */.Z)(ProductDetailTabs, [{
    key: "handleChange",
    value: function handleChange(event, newValue) {
      this.setState({
        value: newValue
      });
    }
  }, {
    key: "expandDescription",
    value: function expandDescription(scrollIntoView) {
      var _this$showMoreRef$cur,
          _this2 = this;

      (_this$showMoreRef$cur = this.showMoreRef.current) === null || _this$showMoreRef$cur === void 0 ? void 0 : _this$showMoreRef$cur.setExpanded();

      if (scrollIntoView) {
        setTimeout(function () {
          var _this2$showMoreRef$cu;

          (_this2$showMoreRef$cu = _this2.showMoreRef.current) === null || _this2$showMoreRef$cu === void 0 ? void 0 : _this2$showMoreRef$cu.scrollIntoView();
        }, 0);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          product = _this$props.product,
          descriptionExpanded = _this$props.descriptionExpanded;
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: {
          width: "100%"
        },
        className: "pt-8 px-8",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
          sx: {
            borderBottom: 1,
            borderColor: "divider"
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Tabs/* default */.Z, {
            value: this.state.value,
            onChange: this.handleChange,
            "aria-label": "basic tabs example",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Tab/* default */.Z, ProductDetailTabs_objectSpread({
              label:
              /*i18n*/
              esm/* i18n._ */.ag._("Description")
            }, a11yProps(0)))
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(TabPanel, {
          value: this.state.value,
          index: 0,
          children: product.description && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "text-base text-gray-700 space-y-6",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(shared_ShowMore, {
              ref: this.showMoreRef,
              jsonStringData: product.description,
              expandable: true,
              expanded: descriptionExpanded
            })
          })
        })]
      });
    }
  }]);

  return ProductDetailTabs;
}(react.Component);

/* harmony default export */ var product_ProductDetailTabs = (ProductDetailTabs);

/***/ }),

/***/ 83293:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NotFoundSeo */
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2962);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);


var NotFoundSeo = function NotFoundSeo() {
  var title = "Not found - GoalsMapper Rewards";
  var description = "Page not found.";
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_0__/* .NextSeo */ .PB, {
    title: title,
    description: description,
    openGraph: {
      title: title,
      description: description,
      images: [{
        url: "https://og-image.vercel.app/React%20Storefront.png?theme=light&md=1&fontSize=100px&images=https%3A%2F%2Fassets.vercel.com%2Fimage%2Fupload%2Ffront%2Fassets%2Fdesign%2Fvercel-triangle-black.svg&images=https%3A%2F%2Fsaleor.io%2Fstatic%2Flogo-ad1b99aa7c6f5acf58a61640af760cfd.svg",
        alt: "GoalsMapper Rewards hero image"
      }],
      site_name: "GoalsMapper Rewards"
    }
  });
};
/* harmony default export */ __webpack_exports__["Z"] = (NotFoundSeo);

/***/ }),

/***/ 24622:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ ProductPageSeo; }
/* harmony export */ });
/* harmony import */ var _lingui_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32601);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);



var ProductPageSeo = function ProductPageSeo(_ref) {
  var _product$thumbnail, _product$thumbnail2;

  var product = _ref.product;
  var title = "".concat((product === null || product === void 0 ? void 0 : product.seoTitle) || (product === null || product === void 0 ? void 0 : product.name), " - ").concat(
  /*i18n*/
  _lingui_core__WEBPACK_IMPORTED_MODULE_0__/* .i18n._ */ .ag._("GoalsMapper Rewards"));

  var description = (product === null || product === void 0 ? void 0 : product.seoDescription) ||
  /*i18n*/
  _lingui_core__WEBPACK_IMPORTED_MODULE_0__/* .i18n._ */ .ag._("Welcome to Goalsmapper Rewards.");

  var thumbnailUrl = ((_product$thumbnail = product.thumbnail) === null || _product$thumbnail === void 0 ? void 0 : _product$thumbnail.url) || "";
  var thumbnailAlt = ((_product$thumbnail2 = product.thumbnail) === null || _product$thumbnail2 === void 0 ? void 0 : _product$thumbnail2.alt) || title;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
    title: title,
    description: description,
    openGraph: {
      title: title,
      description: description,
      images: [{
        url: thumbnailUrl,
        alt: thumbnailAlt
      }],
      site_name:
      /*i18n*/
      _lingui_core__WEBPACK_IMPORTED_MODULE_0__/* .i18n._ */ .ag._("GoalsMapper Rewards")
    }
  });
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (ProductPageSeo)));

/***/ }),

/***/ 19081:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _mui_material_Alert__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(46901);
/* harmony import */ var _mui_icons_material_LocalShipping__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(1645);
/* harmony import */ var _mui_material_Tooltip__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(34386);
/* harmony import */ var _mui_material_Stack__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(51233);
/* harmony import */ var _mui_material_Typography__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(15861);
/* harmony import */ var _home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(50029);
/* harmony import */ var _home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(17674);
/* harmony import */ var _home_circleci_project_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _home_circleci_project_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _lingui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14744);
/* harmony import */ var _lingui_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32601);
/* harmony import */ var _mui_material_Button__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(11057);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(2734);
/* harmony import */ var _mui_material_useMediaQuery__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(98396);
/* harmony import */ var _saleor_sdk__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21637);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(86010);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82175);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var numbro__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(94316);
/* harmony import */ var numbro__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(numbro__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(67294);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(48200);
/* harmony import */ var _components_account__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(92120);
/* harmony import */ var _components_contacts_CheckoutClientBanner__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(40713);
/* harmony import */ var _components_Custom404__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(50430);
/* harmony import */ var _components_ImageExpand__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(50362);
/* harmony import */ var _components_personalize_ProductPersonalize__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(76916);
/* harmony import */ var _components_personalize_utils__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(16825);
/* harmony import */ var _components_product_NewArrivalBadge__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(48321);
/* harmony import */ var _components_product_OnSaleBadge__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(33033);
/* harmony import */ var _components_product_PriceComponent__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(61386);
/* harmony import */ var _components_product_ProductDetailTabs__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(89624);
/* harmony import */ var _components_seo_ProductPageSeo__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(24622);
/* harmony import */ var _components_shared_contexts_ChannelContext__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(59247);
/* harmony import */ var _components_shared_hooks__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(9335);
/* harmony import */ var _components_utils_address__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(76413);
/* harmony import */ var _components_VideoExpand__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(85584);
/* harmony import */ var _lib_util__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(4829);
/* harmony import */ var _saleor_api__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(39259);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(85893);













































var DefaultFormat = "DD-MMM-YYYY";

var ProductPage = function ProductPage(_ref) {
  var _draftData$userDraftC, _draftData$userDraftC2, _productData$product, _productData$product$, _productData$product2, _productData$product3, _productData$product4, _productData$product5, _productData$product6, _productData$product7, _shippingMethods$ship, _router$query$variant, _product$variants2, _selectedVariant$stoc, _product$collections, _product$collections2, _product$collections3, _product$merchant, _product$merchant2, _product$merchant3, _product$merchant4, _product$merchant5;

  var slug = _ref.slug;
  var contentTabsRef = react__WEBPACK_IMPORTED_MODULE_12__.useRef(null);
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_9__.useRouter)();

  var _useAuthState = (0,_saleor_sdk__WEBPACK_IMPORTED_MODULE_3__/* .useAuthState */ .F_)(),
      user = _useAuthState.user,
      authenticated = _useAuthState.authenticated;

  var _useChannelContext = (0,_components_shared_contexts_ChannelContext__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)(),
      channel = _useChannelContext.channel;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)(true),
      showDeliveryDate = _useState[0],
      setShowDeliveryDate = _useState[1];

  var _useProductBySlugQuer = (0,_saleor_api__WEBPACK_IMPORTED_MODULE_29__/* .useProductBySlugQuery */ .fW$)({
    variables: {
      slug: slug || "",
      channel: channel
    },
    skip: !slug,
    fetchPolicy: "cache-and-network"
  }),
      productLoading = _useProductBySlugQuer.loading,
      productData = _useProductBySlugQuer.data;

  var _useCreateCheckoutMut = (0,_saleor_api__WEBPACK_IMPORTED_MODULE_29__/* .useCreateCheckoutMutation */ .F9n)({// refetchQueries: [
    // 	{
    // 		query: UserDraftCheckoutsDocument,
    // 		variables: { first: 100, channel, multipleCheckout: false },
    // 	},
    // ],
    // awaitRefetchQueries: false,
  }),
      _useCreateCheckoutMut2 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)(_useCreateCheckoutMut, 2),
      createCheckout = _useCreateCheckoutMut2[0],
      singleAddLoading = _useCreateCheckoutMut2[1].loading;

  var _useCheckoutBulkCreat = (0,_saleor_api__WEBPACK_IMPORTED_MODULE_29__/* .useCheckoutBulkCreateMutation */ .gj2)({// refetchQueries: [
    // 	{
    // 		query: UserDraftCheckoutsDocument,
    // 		variables: { first: 100, channel, multipleCheckout: false },
    // 	},
    // ],
    // awaitRefetchQueries: false,
  }),
      _useCheckoutBulkCreat2 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)(_useCheckoutBulkCreat, 2),
      bulkCreateCheckout = _useCheckoutBulkCreat2[0],
      bulkCheckoutLoading = _useCheckoutBulkCreat2[1].loading;

  var _useUserDraftCheckout = (0,_saleor_api__WEBPACK_IMPORTED_MODULE_29__/* .useUserDraftCheckoutsQuery */ .Pr_)({
    variables: {
      first: 100,
      multipleCheckout: false
    },
    skip: !authenticated || false,
    fetchPolicy: "network-only"
  }),
      draftData = _useUserDraftCheckout.data,
      loading = _useUserDraftCheckout.loading,
      refetchCheckouts = _useUserDraftCheckout.refetch;

  var _useAccountAddress = (0,_components_account__WEBPACK_IMPORTED_MODULE_14__/* .useAccountAddress */ ._)(),
      _useAccountAddress2 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)(_useAccountAddress, 2),
      getAccountAddress = _useAccountAddress2[0],
      addressLoading = _useAccountAddress2[1];

  var draftCheckouts = (draftData === null || draftData === void 0 ? void 0 : (_draftData$userDraftC = draftData.userDraftCheckouts) === null || _draftData$userDraftC === void 0 ? void 0 : (_draftData$userDraftC2 = _draftData$userDraftC.edges) === null || _draftData$userDraftC2 === void 0 ? void 0 : _draftData$userDraftC2.map(function (edge) {
    return edge.node;
  })) || [];
  var clients = draftCheckouts.map(function (c) {
    return c.profile;
  }).filter(function (n) {
    return !!n;
  });

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)(""),
      addToCartError = _useState2[0],
      setAddToCartError = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)(undefined),
      expandedImage = _useState3[0],
      setExpandedImage = _useState3[1];

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)(undefined),
      videoToPlay = _useState4[0],
      setVideoToPlay = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)(false),
      isExternalProduct = _useState5[0],
      setIsExternalProduct = _useState5[1];

  var _useState6 = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)(undefined),
      externalRedirectUrl = _useState6[0],
      setExternalRedirectUrl = _useState6[1];

  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)(
  /*i18n*/
  _lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("Buy Now")),
      buyNowButtonText = _useState7[0],
      setBuyNowButtonText = _useState7[1];

  var _useSnackbar = (0,_components_shared_hooks__WEBPACK_IMPORTED_MODULE_26__/* .useSnackbar */ .D)(),
      showSnackbar = _useSnackbar.showSnackbar;

  var theme = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z)();
  var isMobile = (0,_mui_material_useMediaQuery__WEBPACK_IMPORTED_MODULE_33__/* ["default"] */ .Z)(theme.breakpoints.down("sm"));
  var product = productData === null || productData === void 0 ? void 0 : productData.product;
  var productId = (product === null || product === void 0 ? void 0 : product.id) || null;

  var _useShippingZonesQuer = (0,_saleor_api__WEBPACK_IMPORTED_MODULE_29__/* .useShippingZonesQuery */ .NWE)({
    skip: !(productData !== null && productData !== void 0 && (_productData$product = productData.product) !== null && _productData$product !== void 0 && (_productData$product$ = _productData$product.merchant) !== null && _productData$product$ !== void 0 && _productData$product$.id),
    variables: {
      channel: channel,
      first: 10,
      filter: {
        merchant: productData === null || productData === void 0 ? void 0 : (_productData$product2 = productData.product) === null || _productData$product2 === void 0 ? void 0 : (_productData$product3 = _productData$product2.merchant) === null || _productData$product3 === void 0 ? void 0 : _productData$product3.id
      }
    }
  }),
      shippingZones = _useShippingZonesQuer.data,
      shippingZonesLoading = _useShippingZonesQuer.loading,
      shippingZonesError = _useShippingZonesQuer.error;

  (0,react__WEBPACK_IMPORTED_MODULE_12__.useEffect)(function () {
    var isExternalProductStr = (0,lodash__WEBPACK_IMPORTED_MODULE_5__.find)(product && (product === null || product === void 0 ? void 0 : product.metadata), {
      key: "external-product"
    });

    if ((isExternalProductStr === null || isExternalProductStr === void 0 ? void 0 : isExternalProductStr.value) === "true") {
      setIsExternalProduct(true);
    } else {
      setIsExternalProduct(false);
    }

    var externalRedirectUrlStr = (0,lodash__WEBPACK_IMPORTED_MODULE_5__.find)(product && (product === null || product === void 0 ? void 0 : product.metadata), {
      key: "external-url"
    });

    if (externalRedirectUrlStr !== null && externalRedirectUrlStr !== void 0 && externalRedirectUrlStr.value) {
      setExternalRedirectUrl(externalRedirectUrlStr.value);
    } else {
      setExternalRedirectUrl(undefined);
    }

    var buyButtonTextStr = (0,lodash__WEBPACK_IMPORTED_MODULE_5__.find)(product && (product === null || product === void 0 ? void 0 : product.metadata), {
      key: "buy-button-text"
    });

    if (buyButtonTextStr !== null && buyButtonTextStr !== void 0 && buyButtonTextStr.value) {
      setBuyNowButtonText(buyButtonTextStr === null || buyButtonTextStr === void 0 ? void 0 : buyButtonTextStr.value);
    } else {
      setBuyNowButtonText(
      /*i18n*/
      _lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("Buy Now"));
    }
  }, [product === null || product === void 0 ? void 0 : product.metadata]);
  (0,react__WEBPACK_IMPORTED_MODULE_12__.useEffect)(function () {
    var _shippingZones$shippi;

    if (shippingZonesLoading) return;
    var shippingZone = shippingZones === null || shippingZones === void 0 ? void 0 : (_shippingZones$shippi = shippingZones.shippingZones) === null || _shippingZones$shippi === void 0 ? void 0 : _shippingZones$shippi.edges[0];
    var deliveryDateHiddenStr = (0,lodash__WEBPACK_IMPORTED_MODULE_5__.find)(shippingZone && (shippingZone === null || shippingZone === void 0 ? void 0 : shippingZone.node.metadata), {
      key: "delivery-date"
    });

    if ((deliveryDateHiddenStr === null || deliveryDateHiddenStr === void 0 ? void 0 : deliveryDateHiddenStr.value) === "hidden") {
      setShowDeliveryDate(false);
    } else {
      setShowDeliveryDate(true);
    }
  }, [shippingZones, shippingZonesLoading]);

  var _useShippingMethodsQu = (0,_saleor_api__WEBPACK_IMPORTED_MODULE_29__/* .useShippingMethodsQuery */ .RvI)({
    skip: !(productData !== null && productData !== void 0 && (_productData$product4 = productData.product) !== null && _productData$product4 !== void 0 && (_productData$product5 = _productData$product4.merchant) !== null && _productData$product5 !== void 0 && _productData$product5.id),
    variables: {
      channel: channel,
      first: 10,
      filter: {
        merchant: productData === null || productData === void 0 ? void 0 : (_productData$product6 = productData.product) === null || _productData$product6 === void 0 ? void 0 : (_productData$product7 = _productData$product6.merchant) === null || _productData$product7 === void 0 ? void 0 : _productData$product7.id,
        products: [productId]
      }
    }
  }),
      shippingMethods = _useShippingMethodsQu.data,
      shippingMethodsLoading = _useShippingMethodsQu.loading,
      shippingMethodsError = _useShippingMethodsQu.error;

  var initialValues = react__WEBPACK_IMPORTED_MODULE_12__.useMemo(function () {
    var returnValue = (product === null || product === void 0 ? void 0 : product.attributes.reduce(function (a, c) {
      if (c.attribute.id) {
        a[c.attribute.id] = "";
      }

      return a;
    }, {})) || {}; //console.log(returnValue);

    return returnValue;
  }, [product === null || product === void 0 ? void 0 : product.attributes, shippingMethods === null || shippingMethods === void 0 ? void 0 : (_shippingMethods$ship = shippingMethods.shippingMethods) === null || _shippingMethods$ship === void 0 ? void 0 : _shippingMethods$ship.edges]);

  if (productLoading) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)(_components__WEBPACK_IMPORTED_MODULE_13__/* .Spinner */ .$j, {});
  }

  if (!(product !== null && product !== void 0 && product.id)) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)(_components_Custom404__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {});
  }

  var getSelectedVariantID = function getSelectedVariantID(queryVariant, product) {
    var _product$variants;

    if (queryVariant) return queryVariant;else if ((product === null || product === void 0 ? void 0 : (_product$variants = product.variants) === null || _product$variants === void 0 ? void 0 : _product$variants.length) === 1) {
      if (true) {
        router.replace({
          pathname: "/products/[slug]",
          query: {
            slug: product.slug,
            variant: product.variants[0].id
          }
        });
      }

      return product.variants[0].id;
    }
    return "";
  }; // We have to check if code is run on the browser
  // before we can use the router


  var queryVariant =  true ? (_router$query$variant = router.query.variant) === null || _router$query$variant === void 0 ? void 0 : _router$query$variant.toString() : 0;
  var selectedVariantID = getSelectedVariantID(queryVariant, product);
  var selectedVariant = product === null || product === void 0 ? void 0 : (_product$variants2 = product.variants) === null || _product$variants2 === void 0 ? void 0 : _product$variants2.find(function (v) {
    return (v === null || v === void 0 ? void 0 : v.id) === selectedVariantID;
  });
  /**
   * If a variant has been selected by the user and this variant has media, return only those items.
   * Otherwise, all product media are returned.
   * @param   {ProductDetailsFragment} product  The product object
   * @param   {ProductVariant} selectedVariant   The selected variant object
   * @return  {ProductMediaFragment[]}   The media object that will be displayed to the user
   */

  var getGalleryMedia = function getGalleryMedia(product, selectedVariant) {
    var _selectedVariant$medi, _selectedVariant$medi2, _product$media;

    if (queryVariant && (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.id) === queryVariant && ((_selectedVariant$medi = selectedVariant.media) === null || _selectedVariant$medi === void 0 ? void 0 : _selectedVariant$medi.length) !== 0) return (selectedVariant === null || selectedVariant === void 0 ? void 0 : (_selectedVariant$medi2 = selectedVariant.media) === null || _selectedVariant$medi2 === void 0 ? void 0 : _selectedVariant$medi2.filter(_lib_util__WEBPACK_IMPORTED_MODULE_34__/* .notNullable */ .Yj)) || [];
    return (product === null || product === void 0 ? void 0 : (_product$media = product.media) === null || _product$media === void 0 ? void 0 : _product$media.filter(_lib_util__WEBPACK_IMPORTED_MODULE_34__/* .notNullable */ .Yj)) || [];
  };

  var media = getGalleryMedia(product, selectedVariant);
  /**
   * When a variant is selected, the variant attributes are shown together with the attributes of the product. Otherwise, onyl the product
   * attributes are shown
   * @param   {ProductDetailsFragment} product  The product object
   * @param   {ProductVariant} selectedVariant   The selected variant object
   * @return  The attributes that will be shown to the user for the chosen product
   */

  var getProductAttributes = function getProductAttributes(product) {
    return product.attributes;
  };

  var attributes = getProductAttributes(product);

  var doCreateCheckout = /*#__PURE__*/function () {
    var _ref2 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_35__/* ["default"] */ .Z)( /*#__PURE__*/_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(values) {
      var _createCheckoutData$c, _createCheckoutData$c2;

      var preferences, _yield$createCheckout, createCheckoutData;

      return _home_circleci_project_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              preferences = attributes.filter(function (attribute) {
                return values[attribute.attribute.id];
              }).map(function (attribute) {
                return {
                  attributeId: attribute.attribute.id,
                  preferenceValue: values[attribute.attribute.id]
                };
              });
              _context.next = 3;
              return createCheckout({
                variables: {
                  checkout: {
                    channel: channel,
                    email: (user === null || user === void 0 ? void 0 : user.email) || "anonymous@example.com",
                    lines: [{
                      quantity: 1,
                      variantId: selectedVariantID,
                      preferences: preferences
                    }],
                    billingAddress: (0,_components_utils_address__WEBPACK_IMPORTED_MODULE_27__/* .cloneAddress */ .K)(getAccountAddress(_saleor_api__WEBPACK_IMPORTED_MODULE_29__/* .AddressTypeEnum.Billing */ .m3h.Billing)) // selectedDeliveryDate: deliveryDateFormatted,

                  }
                }
              });

            case 3:
              _yield$createCheckout = _context.sent;
              createCheckoutData = _yield$createCheckout.data;
              return _context.abrupt("return", (createCheckoutData === null || createCheckoutData === void 0 ? void 0 : (_createCheckoutData$c = createCheckoutData.checkoutCreate) === null || _createCheckoutData$c === void 0 ? void 0 : (_createCheckoutData$c2 = _createCheckoutData$c.errors) === null || _createCheckoutData$c2 === void 0 ? void 0 : _createCheckoutData$c2.filter(function (e) {
                return !!e;
              })) || []);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function doCreateCheckout(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var getPreferences = function getPreferences(checkout, values) {
    if (!values) {
      return [];
    }

    return attributes.map(function (attribute) {
      if (!attribute.attribute.id) {
        return null;
      }

      var value = (0,_components_personalize_utils__WEBPACK_IMPORTED_MODULE_19__/* .normalizePreferenceValue */ .zO)(attribute.attribute, values[attribute.attribute.id], checkout.profile, user);

      if (!value) {
        return null;
      }

      return {
        attributeId: attribute.attribute.id,
        preferenceValue: value
      };
    }).filter(function (c) {
      return !!c;
    }).map(function (c) {
      return c;
    });
  };

  var doMultipleCheckoutCreate = /*#__PURE__*/function () {
    var _ref3 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_35__/* ["default"] */ .Z)( /*#__PURE__*/_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(values) {
      var _draftData$userDraftC3, _checkouts$find, _data$checkoutBulkCre, _data$checkoutBulkCre2;

      var checkouts, checkoutAddress, activeCheckouts, profileIds, deliveryDateFormatted, lines, _yield$bulkCreateChec, data;

      return _home_circleci_project_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              checkouts = draftData === null || draftData === void 0 ? void 0 : (_draftData$userDraftC3 = draftData.userDraftCheckouts) === null || _draftData$userDraftC3 === void 0 ? void 0 : _draftData$userDraftC3.edges.map(function (e) {
                return e.node;
              });
              checkoutAddress = (checkouts === null || checkouts === void 0 ? void 0 : (_checkouts$find = checkouts.find(function (a) {
                return !!a.billingAddress;
              })) === null || _checkouts$find === void 0 ? void 0 : _checkouts$find.billingAddress) || getAccountAddress(_saleor_api__WEBPACK_IMPORTED_MODULE_29__/* .AddressTypeEnum.Billing */ .m3h.Billing);
              activeCheckouts = checkouts === null || checkouts === void 0 ? void 0 : checkouts.filter(function (c) {
                return !!c.profile;
              });
              profileIds = activeCheckouts === null || activeCheckouts === void 0 ? void 0 : activeCheckouts.map(function (c) {
                return c.profile.id;
              });
              deliveryDateFormatted = showDeliveryDate ? moment__WEBPACK_IMPORTED_MODULE_6___default()(values.deliveryDate, DefaultFormat).toDate() : null;
              lines = activeCheckouts === null || activeCheckouts === void 0 ? void 0 : activeCheckouts.map(function (checkout) {
                return {
                  profileId: checkout.profile.id,
                  checkoutLines: [{
                    quantity: 1,
                    variantId: selectedVariantID,
                    preferences: getPreferences(checkout, values)
                  }],
                  shipToAdvisor: false
                };
              });
              _context2.next = 8;
              return bulkCreateCheckout({
                variables: {
                  channel: channel,
                  profileIds: profileIds,
                  lines: lines,
                  billingAddress: (0,_components_utils_address__WEBPACK_IMPORTED_MODULE_27__/* .cloneAddress */ .K)(checkoutAddress) // selectedDeliveryDate: deliveryDateFormatted,

                }
              });

            case 8:
              _yield$bulkCreateChec = _context2.sent;
              data = _yield$bulkCreateChec.data;
              return _context2.abrupt("return", (data === null || data === void 0 ? void 0 : (_data$checkoutBulkCre = data.checkoutBulkCreate) === null || _data$checkoutBulkCre === void 0 ? void 0 : (_data$checkoutBulkCre2 = _data$checkoutBulkCre.errors) === null || _data$checkoutBulkCre2 === void 0 ? void 0 : _data$checkoutBulkCre2.filter(function (e) {
                return !!e;
              })) || []);

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function doMultipleCheckoutCreate(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  var checkShouldBulkCheckout = function checkShouldBulkCheckout() {
    var _draftData$userDraftC4, _draftData$userDraftC5;

    var numberOfCheckouts = (draftData === null || draftData === void 0 ? void 0 : (_draftData$userDraftC4 = draftData.userDraftCheckouts) === null || _draftData$userDraftC4 === void 0 ? void 0 : _draftData$userDraftC4.totalCount) || 0;
    var checkouts = (draftData === null || draftData === void 0 ? void 0 : (_draftData$userDraftC5 = draftData.userDraftCheckouts) === null || _draftData$userDraftC5 === void 0 ? void 0 : _draftData$userDraftC5.edges.map(function (e) {
      return e.node;
    })) || [];
    var hasMoreThanOneCheckout = numberOfCheckouts > 1; // More than one checkouts usually means that a contact has been assigned the user is probably just changing the product.

    if (hasMoreThanOneCheckout) return true;

    if (numberOfCheckouts === 1) {
      var _checkout$profile;

      var checkout = checkouts[0];
      var hasProfile = (_checkout$profile = checkout.profile) === null || _checkout$profile === void 0 ? void 0 : _checkout$profile.id;
      return hasProfile !== undefined;
    }

    return false;
  };

  var onAddToCart = /*#__PURE__*/function () {
    var _ref4 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_35__/* ["default"] */ .Z)( /*#__PURE__*/_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3(values) {
      var errors, errorMessages;
      return _home_circleci_project_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              setAddToCartError("");

              if (!isExternalProduct) {
                _context3.next = 4;
                break;
              }

              if (externalRedirectUrl && externalRedirectUrl.length > 0) {
                window.open(externalRedirectUrl, externalRedirectUrl.startsWith("mailto:") ? "_self" : "_blank");
              } else {
                showSnackbar({
                  message:
                  /*i18n*/
                  _lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("An unexpected error happened! Please try again later."),
                  severity: "error",
                  horizontal: "center"
                });
              }

              return _context3.abrupt("return");

            case 4:
              if (!checkShouldBulkCheckout()) {
                _context3.next = 10;
                break;
              }

              _context3.next = 7;
              return doMultipleCheckoutCreate(values);

            case 7:
              _context3.t0 = _context3.sent;
              _context3.next = 13;
              break;

            case 10:
              _context3.next = 12;
              return doCreateCheckout(values);

            case 12:
              _context3.t0 = _context3.sent;

            case 13:
              errors = _context3.t0;

              if (!(errors.length === 0)) {
                _context3.next = 17;
                break;
              }

              // Product successfully added, redirect to cart page
              router.push("/cart");
              return _context3.abrupt("return");

            case 17:
              // Display error message
              errorMessages = errors.map(function (e) {
                return e.message || "";
              }) || [];
              setAddToCartError(errorMessages.join("\n"));

            case 19:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function onAddToCart(_x3) {
      return _ref4.apply(this, arguments);
    };
  }();

  var loadingAddToCheckout = singleAddLoading || bulkCheckoutLoading;
  var isAddToCartButtonDisabled = !selectedVariant || (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.stocks) && (selectedVariant === null || selectedVariant === void 0 ? void 0 : (_selectedVariant$stoc = selectedVariant.stocks[0]) === null || _selectedVariant$stoc === void 0 ? void 0 : _selectedVariant$stoc.quantity) === 0 || loadingAddToCheckout;
  var isNewArrival = (_product$collections = product.collections) === null || _product$collections === void 0 ? void 0 : _product$collections.find(function (c) {
    return (c === null || c === void 0 ? void 0 : c.slug) === "new-arrivals";
  });
  var isFreeDelivery = (_product$collections2 = product.collections) === null || _product$collections2 === void 0 ? void 0 : _product$collections2.find(function (c) {
    return (c === null || c === void 0 ? void 0 : c.slug) === "free-delivery";
  });
  var isPersonalisable = (_product$collections3 = product.collections) === null || _product$collections3 === void 0 ? void 0 : _product$collections3.find(function (c) {
    return (c === null || c === void 0 ? void 0 : c.slug) === "personalise";
  });

  var renderProductHints = function renderProductHints() {
    var _product$collections4, _product$collections5, _product$collections6, _product$collections7, _product$collections8;

    var isSocialEnterprise = (_product$collections4 = product.collections) === null || _product$collections4 === void 0 ? void 0 : _product$collections4.find(function (c) {
      return (c === null || c === void 0 ? void 0 : c.slug) === "social-enterprise";
    });
    var isHalal = (_product$collections5 = product.collections) === null || _product$collections5 === void 0 ? void 0 : _product$collections5.find(function (c) {
      return (c === null || c === void 0 ? void 0 : c.slug) === "halal-muslim-friendly";
    });
    var isVegan = (_product$collections6 = product.collections) === null || _product$collections6 === void 0 ? void 0 : _product$collections6.find(function (c) {
      return (c === null || c === void 0 ? void 0 : c.slug) === "vegan";
    });
    var isVegetarian = (_product$collections7 = product.collections) === null || _product$collections7 === void 0 ? void 0 : _product$collections7.find(function (c) {
      return (c === null || c === void 0 ? void 0 : c.slug) === "vegetarian";
    });
    var isNextDayDelivery = (_product$collections8 = product.collections) === null || _product$collections8 === void 0 ? void 0 : _product$collections8.find(function (c) {
      return (c === null || c === void 0 ? void 0 : c.slug) === "next-day-delivery";
    }); // const pricing = selectedVariant?.pricing || product.pricing;
    // const isOnSale = pricing?.onSale || false;

    if (!isPersonalisable && !isSocialEnterprise && !isHalal && !isVegetarian && !isVegan && !isNextDayDelivery) return false;
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)("div", {
      className: "flex flex-row space-x-2 border px-4 py-2 border-gray-300 rounded-md items-center",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsxs)(_mui_material_Stack__WEBPACK_IMPORTED_MODULE_36__/* ["default"] */ .Z, {
        direction: "row",
        justifyContent: "flex-start",
        flex: 1,
        flexWrap: "nowrap",
        spacing: 2,
        children: [isPersonalisable && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)(_mui_material_Tooltip__WEBPACK_IMPORTED_MODULE_37__/* ["default"] */ .Z, {
          title:
          /*i18n*/
          _lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("Personalise your Gift"),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsxs)(_mui_material_Stack__WEBPACK_IMPORTED_MODULE_36__/* ["default"] */ .Z, {
            direction: "column",
            alignItems: "center",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
              src: "/icons/personalised-gift.svg",
              alt: "",
              width: 30,
              height: 30
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z, {
              variant: "body2",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_1__/* .Trans */ .cC, {
                id: "Personalise"
              })
            })]
          })
        }), isSocialEnterprise && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)(_mui_material_Tooltip__WEBPACK_IMPORTED_MODULE_37__/* ["default"] */ .Z, {
          title:
          /*i18n*/
          _lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("Social Enterprise"),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsxs)(_mui_material_Stack__WEBPACK_IMPORTED_MODULE_36__/* ["default"] */ .Z, {
            direction: "column",
            alignItems: "center",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
              src: "/icons/social-enterprise.svg",
              alt: "",
              width: 30,
              height: 30
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z, {
              variant: "body2",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_1__/* .Trans */ .cC, {
                id: "Social Enterprise"
              })
            })]
          })
        }), isHalal && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)(_mui_material_Tooltip__WEBPACK_IMPORTED_MODULE_37__/* ["default"] */ .Z, {
          title:
          /*i18n*/
          _lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("Halal Certified"),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsxs)(_mui_material_Stack__WEBPACK_IMPORTED_MODULE_36__/* ["default"] */ .Z, {
            direction: "column",
            alignItems: "center",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
              src: "/icons/halal.svg",
              alt: "",
              width: 30,
              height: 30
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z, {
              variant: "body2",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_1__/* .Trans */ .cC, {
                id: "Halal Certified"
              })
            })]
          })
        }), isVegan && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)(_mui_material_Tooltip__WEBPACK_IMPORTED_MODULE_37__/* ["default"] */ .Z, {
          title:
          /*i18n*/
          _lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("Vegan"),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsxs)(_mui_material_Stack__WEBPACK_IMPORTED_MODULE_36__/* ["default"] */ .Z, {
            direction: "column",
            alignItems: "center",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
              src: "/icons/vegan.svg",
              alt: "",
              width: 30,
              height: 30
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z, {
              variant: "body2",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_1__/* .Trans */ .cC, {
                id: "Vegan"
              })
            })]
          })
        }), isVegetarian && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)(_mui_material_Tooltip__WEBPACK_IMPORTED_MODULE_37__/* ["default"] */ .Z, {
          title:
          /*i18n*/
          _lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("Vegetarian"),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsxs)(_mui_material_Stack__WEBPACK_IMPORTED_MODULE_36__/* ["default"] */ .Z, {
            direction: "column",
            alignItems: "center",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
              src: "/icons/vegetarian.svg",
              alt: "",
              width: 30,
              height: 30
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z, {
              variant: "body2",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_1__/* .Trans */ .cC, {
                id: "Vegetarian"
              })
            })]
          })
        }), isNextDayDelivery && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)(_mui_material_Tooltip__WEBPACK_IMPORTED_MODULE_37__/* ["default"] */ .Z, {
          title:
          /*i18n*/
          _lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("Next Day Delivery"),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsxs)(_mui_material_Stack__WEBPACK_IMPORTED_MODULE_36__/* ["default"] */ .Z, {
            direction: "column",
            alignItems: "center",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
              src: "/icons/next-day-delivery.svg",
              alt: "",
              width: 30,
              height: 30
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z, {
              variant: "body2",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_1__/* .Trans */ .cC, {
                id: "Next Day Delivery"
              })
            })]
          })
        })]
      })
    });
  };

  var hasMedia = product.media && product.media.length > 0;

  var renderDeliveryTimeAndCost = function renderDeliveryTimeAndCost() {
    var _shippingMethods$ship2, _freeShipping$node$mi, _defaultShipping$node;

    var shippingMethodEdges = shippingMethods === null || shippingMethods === void 0 ? void 0 : (_shippingMethods$ship2 = shippingMethods.shippingMethods) === null || _shippingMethods$ship2 === void 0 ? void 0 : _shippingMethods$ship2.edges;
    var minimumOrderPrice = null;
    var deliveryPrice = null;
    var warehouses = shippingMethodEdges && shippingMethodEdges[0].node.warehouses;
    var countries = warehouses && warehouses.length > 0 && warehouses.map(function (warehouse) {
      return warehouse.countries;
    });

    var countryNames = countries && countries.length > 0 && lodash__WEBPACK_IMPORTED_MODULE_5___default().flatten(countries).map(function (country) {
      return country && country.name;
    });

    var stock = selectedVariant !== null && selectedVariant !== void 0 && selectedVariant.quantityAvailable && selectedVariant.quantityAvailable > 0 ? selectedVariant.quantityAvailable : null;
    if (shippingMethodEdges && shippingMethodEdges.length === 0) return;
    var defaultShipping = (0,lodash__WEBPACK_IMPORTED_MODULE_5__.find)(shippingMethodEdges, function (method) {
      var defaultMetaData = (0,lodash__WEBPACK_IMPORTED_MODULE_5__.find)(method.node.metadata, {
        key: "default"
      });
      return (defaultMetaData === null || defaultMetaData === void 0 ? void 0 : defaultMetaData.value) === "true";
    });
    var freeShipping = (0,lodash__WEBPACK_IMPORTED_MODULE_5__.find)(shippingMethodEdges, function (method) {
      var defaultMetaData = (0,lodash__WEBPACK_IMPORTED_MODULE_5__.find)(method.node.metadata, {
        key: "free"
      });
      return (defaultMetaData === null || defaultMetaData === void 0 ? void 0 : defaultMetaData.value) === "true";
    });
    minimumOrderPrice = freeShipping && ((_freeShipping$node$mi = freeShipping.node.minimumOrderPrice) === null || _freeShipping$node$mi === void 0 ? void 0 : _freeShipping$node$mi.amount) || null;
    deliveryPrice = defaultShipping && ((_defaultShipping$node = defaultShipping.node.price) === null || _defaultShipping$node === void 0 ? void 0 : _defaultShipping$node.amount) || null;
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsxs)(_mui_material_Stack__WEBPACK_IMPORTED_MODULE_36__/* ["default"] */ .Z, {
      direction: "row",
      justifyContent: "space-between",
      alignItems: "center",
      spacing: 2,
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)("div", {
        className: "flex flex-col",
        children: stock && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z, {
          variant: "body2",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_1__/* .Trans */ .cC, {
            id: "{stock, plural, zero {Out of stock!} =0 {Out of stock!} one {# item in stock} other {# items in stock}}",
            values: {
              stock: stock
            }
          })
        })
      }), deliveryPrice && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsxs)(_mui_material_Stack__WEBPACK_IMPORTED_MODULE_36__/* ["default"] */ .Z, {
        direction: "column",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsxs)(_mui_material_Stack__WEBPACK_IMPORTED_MODULE_36__/* ["default"] */ .Z, {
          direction: "row",
          justifyContent: "flex-end",
          spacing: 2,
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)(_mui_icons_material_LocalShipping__WEBPACK_IMPORTED_MODULE_39__/* ["default"] */ .Z, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z, {
            variant: "body2",
            children: numbro__WEBPACK_IMPORTED_MODULE_10___default()(deliveryPrice).format("$0,0.00")
          })]
        }), minimumOrderPrice && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z, {
          variant: "body2",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_1__/* .Trans */ .cC, {
            id: "Enjoy free delivery to one location for orders above {0}!",
            values: {
              "0": numbro__WEBPACK_IMPORTED_MODULE_10___default()(minimumOrderPrice).format("$0,0.00")
            }
          })
        })]
      })]
    });
  };

  var validateForm = function validateForm(values) {
    if (Object.keys(initialValues).length === 0) {
      return {};
    }

    var errors = {};
    var validationMeta = (0,_components_personalize_utils__WEBPACK_IMPORTED_MODULE_19__/* .getAttributesValidationMeta */ .z4)(attributes.map(function (c) {
      return c.attribute;
    }));
    attributes.forEach(function (_ref5) {
      var attribute = _ref5.attribute;
      var validationItem = validationMeta[attribute.id];

      if (validationItem) {
        if (validationItem.required && !values[attribute.id]) {
          errors[attribute.id] =
          /*i18n*/
          _lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("Field is required");
        }
      }
    });
    return errors;
  };

  var renderFreeDelivery = function renderFreeDelivery() {
    if (!isFreeDelivery) return false;
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)("div", {
      className: "flex text-yellow-500 font-semibold text-lg flex-row justify-end",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_1__/* .Trans */ .cC, {
        id: "Free Delivery"
      })
    });
  };

  var stock = selectedVariant !== null && selectedVariant !== void 0 && selectedVariant.quantityAvailable && selectedVariant.quantityAvailable > 0 ? selectedVariant.quantityAvailable : 0;

  var renderForm = function renderForm() {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)(formik__WEBPACK_IMPORTED_MODULE_4__/* .Formik */ .J9, {
      initialValues: initialValues,
      onSubmit: onAddToCart,
      validate: validateForm,
      enableReinitialize: true,
      children: function children(_ref6) {
        var values = _ref6.values,
            setFieldValue = _ref6.setFieldValue;
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)(formik__WEBPACK_IMPORTED_MODULE_4__/* .Form */ .l0, {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsxs)(_mui_material_Stack__WEBPACK_IMPORTED_MODULE_36__/* ["default"] */ .Z, {
            spacing: 2,
            children: [selectedVariant && stock <= 0 &&
            /*#__PURE__*/
            // <p className="text-lg- text-yellow-600">Sold out!</p>
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)(_mui_material_Alert__WEBPACK_IMPORTED_MODULE_40__/* ["default"] */ .Z, {
              severity: "warning",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_1__/* .Trans */ .cC, {
                id: "Sold Out!"
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)(_components__WEBPACK_IMPORTED_MODULE_13__/* .VariantSelector */ .Ak, {
              product: product,
              selectedVariantID: selectedVariantID
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)(_components_personalize_ProductPersonalize__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
              product: product,
              variant: "product"
            }), !selectedVariant && authenticated && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)("p", {
              className: "text-lg- text-yellow-600",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_1__/* .Trans */ .cC, {
                id: "Please choose an option"
              })
            }), !!addToCartError && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)("p", {
              className: "text-red-600",
              children: addToCartError
            }), !shippingMethodsLoading && !shippingMethodsError && !isExternalProduct && renderDeliveryTimeAndCost(), renderFreeDelivery(), authenticated ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)(_mui_material_Button__WEBPACK_IMPORTED_MODULE_41__/* ["default"] */ .Z, {
              type: "submit",
              variant: "contained",
              color: "secondary",
              disabled: isAddToCartButtonDisabled || !authenticated || loading || stock <= 0 || clients.length > stock || addressLoading,
              fullWidth: true,
              disableElevation: true,
              className: "text-white",
              children: loadingAddToCheckout ?
              /*i18n*/
              _lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("Adding...") : buyNowButtonText
            }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)(_mui_material_Button__WEBPACK_IMPORTED_MODULE_41__/* ["default"] */ .Z, {
              variant: "contained",
              color: "secondary",
              disabled: loading,
              fullWidth: true,
              disableElevation: true,
              href: "/account/login".concat(router.asPath !== "/" ? qs__WEBPACK_IMPORTED_MODULE_11___default().stringify({
                next: router.asPath
              }, {
                addQueryPrefix: true
              }) : ""),
              className: "text-white",
              children:
              /*i18n*/
              _lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("Log In")
            }), clients.length > stock && selectedVariant && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)("section", {
              className: "col-span-3 text-center",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)(_mui_material_Stack__WEBPACK_IMPORTED_MODULE_36__/* ["default"] */ .Z, {
                spacing: 2,
                alignItems: "center",
                justifyContent: "center",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)("div", {
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)("div", {
                    className: "text-s font-semibold text-red-700",
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_1__/* .Trans */ .cC, {
                      id: "{stock, plural, zero {This product is out of stock.} =0 {This product is out of stock.} one {\"There is only # item of the product in Stock.\"} other {\"There are only # items of the product in Stock.\"}}",
                      values: {
                        stock: stock
                      }
                    })
                  })
                })
              })
            })]
          })
        });
      }
    });
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)(_components_seo_ProductPageSeo__WEBPACK_IMPORTED_MODULE_24__/* .ProductPageSeo */ .P, {
      product: product
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsxs)("main", {
      className: (0,clsx__WEBPACK_IMPORTED_MODULE_42__/* ["default"] */ .Z)("max-h-full overflow-auto md:overflow-hidden mx-auto max-w-7xl pt-8 md:px-8 pb-8", expandedImage && "hidden", videoToPlay && "hidden"),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)(_components_contacts_CheckoutClientBanner__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
        onClose: refetchCheckouts,
        selectedVariant: selectedVariant
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsxs)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_42__/* ["default"] */ .Z)("grid grid-cols-1 gap-12 lg:gap-16 mt-6", {
          "lg:grid-cols-7": hasMedia
        }),
        children: [hasMedia && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsxs)("div", {
          className: (0,clsx__WEBPACK_IMPORTED_MODULE_42__/* ["default"] */ .Z)("w-full max-h-screen col-span-1 lg:h-full relative lg:col-span-3"),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)(_components__WEBPACK_IMPORTED_MODULE_13__/* .ProductMediaCarousel */ .IQ, {
            media: media,
            onMediaClick: function onMediaClick(media) {
              return setExpandedImage(media);
            }
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsxs)(_mui_material_Stack__WEBPACK_IMPORTED_MODULE_36__/* ["default"] */ .Z, {
            direction: "row",
            spacing: 1,
            className: "absolute left-2 top-2",
            alignItems: "flex-start",
            children: [isNewArrival && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)(_components_product_NewArrivalBadge__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {}), product.id && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)(_components_product_OnSaleBadge__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
              productId: product.id
            })]
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsxs)("div", {
          className: "space-y-6 mt-10 lg:mt-0 col-span-1 px-8 lg:col-span-4",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsxs)("div", {
            className: "space-y-1",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)("h1", {
              className: "text-4xl font-bold tracking-tight text-gray-800",
              children: product === null || product === void 0 ? void 0 : product.name
            }), product.merchant && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsxs)(_mui_material_Stack__WEBPACK_IMPORTED_MODULE_36__/* ["default"] */ .Z, {
              direction: "row",
              spacing: 1,
              pt: 1,
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)("div", {
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_1__/* .Trans */ .cC, {
                  id: "Merchant:"
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                href: {
                  pathname: "/merchant/[slug]",
                  query: {
                    slug: (_product$merchant = product.merchant) === null || _product$merchant === void 0 ? void 0 : _product$merchant.slug
                  }
                },
                passHref: true,
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)("a", {
                  children: (_product$merchant2 = product.merchant) === null || _product$merchant2 === void 0 ? void 0 : _product$merchant2.name
                })
              })]
            })]
          }), renderProductHints(), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)(_components_product_PriceComponent__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
            product: product,
            size: "large",
            selectedVariantId: selectedVariantID
          }), renderForm()]
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)(_components_product_ProductDetailTabs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
        ref: contentTabsRef,
        product: product,
        descriptionExpanded: true
      }), product.merchant && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)("div", {
        className: "mx-auto pt-20 px-8",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)(_components__WEBPACK_IMPORTED_MODULE_13__/* .CollectionBlock */ .Xq, {
          iconName: "balloons",
          title:
          /*i18n*/
          _lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("More from merchant"),
          link: "/merchant/".concat((_product$merchant3 = product.merchant) === null || _product$merchant3 === void 0 ? void 0 : _product$merchant3.slug),
          filter: {
            merchants: (_product$merchant4 = product.merchant) !== null && _product$merchant4 !== void 0 && _product$merchant4.id ? [(_product$merchant5 = product.merchant) === null || _product$merchant5 === void 0 ? void 0 : _product$merchant5.id] : null
          }
        })
      })]
    }), expandedImage && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)("div", {
      className: "absolute min-h-screen min-w-screen h-full w-full top-0 bottom-0 left-0 right-0 z-40",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)(_components_ImageExpand__WEBPACK_IMPORTED_MODULE_17__/* .ImageExpand */ .o, {
        image: expandedImage,
        onRemoveExpand: function onRemoveExpand() {
          return setExpandedImage(undefined);
        }
      })
    }), videoToPlay && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)("div", {
      className: "absolute min-h-screen min-w-screen top-0 bottom-0 left-0 right-0 z-40",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)(_components_VideoExpand__WEBPACK_IMPORTED_MODULE_28__/* .VideoExpand */ .H, {
        video: videoToPlay,
        onRemoveExpand: function onRemoveExpand() {
          return setVideoToPlay(undefined);
        }
      })
    })]
  });
};

var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (ProductPage);

ProductPage.getLayout = function getLayout(page) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)(_components__WEBPACK_IMPORTED_MODULE_13__/* .Layout */ .Ar, {
    children: page
  });
};

/***/ }),

/***/ 95159:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/[slug]",
      function () {
        return __webpack_require__(19081);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4885,3234,3662,2962,9964,6149,8105,7259,2336,3396,129,4294,7240,3982,5608,5912,4401,3713,285,2174,2987,3261,8629,8200,9748,9774,2888,179], function() { return __webpack_exec__(95159); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);